export type ButtonStyle =
  | "base"
  | "baseInverted"
  | "primary"
  | "secondary"
  | "danger"
  | "success"
  | "warning";
